<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="单位名称">
					<c-input name="unit" maxlength="50"></c-input>
				</m-search-item>
				<m-search-item label="备注">
					<c-input name="remark" maxlength="50"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_unit_edit')" prepend-icon="tf-add" @click="editDicUnit()">创建单位</c-button>

				<template #batch>
					<c-button v-if="auth('b_unit_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveDicUnit">删除</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow" :paging="true">
				<c-table-column
					type="selector"
					width="32"
					@handle="batchSelect"
				></c-table-column>

				<c-table-column
					label="单位名称"
					name="unit"
					width="200"
				>
				</c-table-column>
				
				<c-table-column
					label="备注"
					name="remark"
					width="300"
				>
					<template #default="{data}">
						<span v-if="data.remark">{{data.remark}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="110"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_unit_edit')" icon="tf-edit" @click="editDicUnit(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_unit_edit')" icon="tf-trash" color="red" @click="removeDicUnit(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--创建/编辑单位信息弹窗-->
			<unit-edit ref="unitEdit" @resolve="$refs.list.update()"></unit-edit>
		</module>
	</page>
</template>

<script>
	import unitEdit from "@/pages/basic/dic_unit_edit.vue";
	import {batchData, batchMethods} from '@/components/public/batch.js'

	export default {
		components: {
			unitEdit
		},
		
		props: {
			type: String
		},

		data() {
			return {
				...batchData()
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			...batchMethods(),

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/dic/unit/list',
					data,
					success: () => {
						this.batchData = [];
					}
				});
			},

			/******新建/编辑单位*******/
			editDicUnit(data) {
				this.$refs.unitEdit.open(data);
			},

			/****批量删除单位****/
			batchRemoveDicUnit(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条单位记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/unit/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除单位***********/
			removeDicUnit(data){
				this.$confirm({
					message:'确认删除单位【'+data.unit+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/unit/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>